import { render, staticRenderFns } from "./Buynsell.vue?vue&type=template&id=8287cfe4&"
import script from "./Buynsell.vue?vue&type=script&lang=js&"
export * from "./Buynsell.vue?vue&type=script&lang=js&"
import style0 from "./Buynsell.vue?vue&type=style&index=0&id=8287cfe4&prod&scopped=true&lang=css&"
import style1 from "./Buynsell.vue?vue&type=style&index=1&id=8287cfe4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports